import { Navigate, useParams, useSearchParams } from "react-router";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";
import ObjectDetailsPage from "../../../entityFields/ObjectDetailsPage";

const WorkflowChecklistDetailsPage = () => {
  const { id, type } = useParams();
  const [queryParams] = useSearchParams();
  const { clientCode } = useClientContext();

  if (!id || !type) {
    return <Navigate to=".." />;
  }

  const workflowTemplateId = queryParams.get("workflowTemplateId");
  const workflowId = queryParams.get("workflowId");

  const backButtonPath =
    workflowTemplateId && workflowId
      ? `/${clientCode}/${pageRoutes.workflows}/${pageRoutes.workflowRuns}/${workflowTemplateId}/${workflowId}`
      : `/${clientCode}/${pageRoutes.workflows}/${pageRoutes.workflowRuns}`;

  return <ObjectDetailsPage objectId={id} objectType={type} backButtonPath={backButtonPath} />;
};

export default WorkflowChecklistDetailsPage;
